import React, { useCallback, useEffect, useState } from "react";

import { fetchWrapper } from "@helpers/fetchwrapper";

import notPhoto from "@content/img/notPhoto.jpg";

import styles from "./styles/partners.module.css";

function Partners() {
  const [data, setData] = useState([]);

  const loadData = useCallback(() => {
    fetchWrapper.get("/data/partners.json").then((res) => {
      setData(res);
    });
  }, []);

  useEffect(() => {
    loadData();
  }, [loadData]);

  const renderPartnerCard = (item) => (
    <>
      <div className={styles.photo}>
        {item.photo ? (
          <img src={item.photo} alt="Фото" />
        ) : (
          <img src={notPhoto} alt="Фото" />
        )}
      </div>
      <div className={styles.info}>
        <div className={styles.title}>
          <div className={styles.name}>{item.name}</div>
        </div>
      </div>
    </>
  );

  return (
    <div className={`${styles.block} container`}>
      <div className={styles.header}>Партнеры</div>
      <div className={styles.partners}>
        {data.map((item, index) =>
          item.link ? (
            <a
              key={index}
              href={item.link}
              target="_blank"
              rel="noopener noreferrer"
              className={`${styles.partner} ${styles.partnerLink}`}
            >
              {renderPartnerCard(item)}
            </a>
          ) : (
            <div key={index} className={styles.partner}>
              {renderPartnerCard(item)}
            </div>
          )
        )}
      </div>
    </div>
  );
}

export default Partners;
